import React, { Component } from 'react'
import { Table, Button, Popconfirm, Icon } from 'antd'
import { withRouter } from 'react-router-dom'
import { users } from '@services/api'
import family from '@pages/Clients/Client/TopSection/components/Family'

class Clients extends Component<any> {
    state = {
        loader: false
    }
    render() {
        const { list, loading, updateInfo, isAdmin, agentName, paginate } = this.props

        let statuses = {
            HOLD: 'לקוח אישר, ממתין לרישום',
            WAITING: ' ממתין לאישור לקוח',
            CANCELED: 'הזמנה בוטלה על ידי הסוכן',
            DECLINED: 'הזמנה סורבה',
            BLOCKED: 'לקוח אישר, ממתין למקום במנוי של הסוכן',
            APPROVED: 'הזמנה אושרה',
            DELETED: 'משתמש נמחק',
            HIDDEN: ' - הסוכן הסתיר את הלקוח מהרשימה'
        }
        const columns = [
            {
                title: 'שם פרטי',
                key: 'first_name',
                width: 200,
                align: 'right',
                render: (_, record) => (
                    <div>
                        {record.client_first_name
                            ? record.client_first_name
                            : !record.content
                            ? 'אין שם בהזמנה'
                            : JSON.parse(record.content).first_name}
                    </div>
                )
            },
            {
                title: 'שם משפחה',
                key: 'last_name',
                align: 'right',
                render: (_, record) => (
                    <div>
                        {record.client_last_name
                            ? record.client_last_name
                            : !record.content
                            ? 'אין שם בהזמנה'
                            : JSON.parse(record.content).last_name}
                    </div>
                )
            },
            {
                title: 'טלפון',
                key: 'phone',
                align: 'right',
                render: (_, record) => <div>0{record.phone}</div>
            },
            {
                title: 'סוג',
                key: 'type',
                align: 'right',
                render: (_, record) => <div>{record.type === 'NEW' ? 'משתמש חדש' : 'משתמש קיים'}</div>
            },
            {
                title: 'מזהה',
                key: 'id',
                width: 70,
                align: 'right',
                render: (_, record) => (
                    <div
                        style={{
                            color: record.related_id ? 'blue' : undefined,
                            textDecoration: record.related_id ? 'underline' : '',
                            cursor: record.related_id ? 'pointer' : undefined
                        }}
                        onClick={() => {
                            record.related_id && window.open(`/clients/${record.related_id}`, '_blank')
                        }}
                    >
                        {record.related_id || 'אין מזהה'}
                    </div>
                )
            },
            {
                title: 'סטטוס',
                key: 'status',
                width: 300,
                align: 'right',
                render: (_, record) => (
                    <div style={{ color: record.client_status === 'DELETED' ? 'red' : undefined }}>
                        {record.client_status === 'DELETED' ? statuses.DELETED : statuses[record.status]}
                        {record.hide ? statuses.HIDDEN : ''}
                    </div>
                )
            },
            {
                title: 'מינוי',
                key: 'subscription',
                width: 300,
                align: 'right',
                render: (_, record) => (
                    <div
                        title={
                            record.subscription_status === 'AWAITING_BANK_APPROVAL' ||
                            record.subscription_status === 'AWAITING_BANK_TRANSFER'
                                ? record.subscription_name
                                : ''
                        }
                        style={{
                            color:
                                record.subscription_status === 'AWAITING_BANK_TRANSFER' ||
                                record.subscription_status === 'BLOCKED'
                                    ? 'red'
                                    : undefined
                        }}
                    >
                        {record.subscription_id &&
                        record.subscription_status !== 'AWAITING_BANK_APPROVAL' &&
                        record.subscription_status !== 'AWAITING_BANK_TRANSFER' &&
                        record.subscription_status !== 'BLOCKED'
                            ? record.subscription_name
                            : record.subscription_status === 'AWAITING_BANK_APPROVAL'
                            ? 'ממתין לאישור בנק'
                            : record.subscription_status === 'AWAITING_BANK_TRANSFER' ||
                              record.subscription_status === 'BLOCKED'
                            ? 'חסום - עד להסדרת תשלום'
                            : '-'}
                    </div>
                )
            },
            {
                title: 'תאריך רכישת מינוי',
                key: 'subscriptionDate',
                width: 300,
                align: 'right',
                render: (_, record) => <div>{record.subscription_paid_at ? record.subscription_paid_at : '-'}</div>
            }
        ]
        return (
            <Table
                className="center-table"
                style={{ width: '100%' }}
                rowKey="id"
                loading={this.state.loader || !list.data}
                columns={columns}
                rowClassName={record => record.policy_id}
                dataSource={list.data}
                onChange={(page, perPage) => {
                    this.setState({ loader: true })
                    paginate({ page, perPage }).then(res => this.setState({ loader: res }))
                }}
                pagination={{
                    total: list.total,
                    pageSize: list.perPage,
                    hideOnSinglePage: true
                }}
            />
        )
    }
}

export default withRouter(Clients)
